import { HttpClient } from '@angular/common/http';
import { inject, Injectable, isDevMode } from '@angular/core';

import { forkJoin, map, type Observable } from 'rxjs';

import type { Translation, TranslocoLoader, TranslocoOptions } from '@jsverse/transloco';
import { TranslocoLoaderData } from '@jsverse/transloco/lib/transloco.loader';
import deepmerge from 'deepmerge';

import { environment } from '@client/environments/environment';

@Injectable({
  providedIn: 'root'
})
class TranslocoHttpLoader implements TranslocoLoader {
  readonly #http = inject(HttpClient);

  readonly #URL_PREFIX = 'assets/i18n/' as const;
  readonly #URL_SUFFIX = '.json' as const;
  readonly #RESOURCES = [
    'client',
    'admin'
  ] as const;

  getTranslation(languageCode: string, data: TranslocoLoaderData): Observable<Translation> {
    return this.#http.get<Translation>(this.#buildUrl(languageCode));
  }

  #buildLegacyUrl(resource: string, languageCode: string): string {
    const url = new URL(`${this.#URL_PREFIX}${resource}-${languageCode}${this.#URL_SUFFIX}`, window.location.origin);

    url.searchParams.append('version', environment.app_version);

    return url.toString();
  }

  #buildUrl(languageCode: string): string {
    const url = new URL(`${this.#URL_PREFIX}${languageCode}${this.#URL_SUFFIX}`, window.location.origin);

    url.searchParams.append('version', environment.app_version);

    return url.toString();
  }
}

export const TRANSLOCO_OPTIONS: TranslocoOptions = {
  config: {
    availableLangs: [
      'ar',
      'cs',
      'de',
      'en',
      'es',
      'gb',
      'pl',
      'sk',
      'sl',
      'hu',
      'pt'
    ],
    defaultLang: 'en',
    failedRetries: 1,
    fallbackLang: 'en',
    prodMode: !isDevMode(),
    reRenderOnLangChange: true, // TODO possible optimization but page reload needed
    missingHandler: {
      allowEmpty: true,
      logMissingKey: false,
      useFallbackTranslation: true
    }
  },
  loader: TranslocoHttpLoader
};
